import { Stack } from '@mui/material';
import { MgItemCard, MgSupplierItemCard, MgSupplierItemPackage } from '@retail/products/types';
import { MgSupplierItemPackagesTable } from './MgSupplierItemPackagesTable';
import { SupplierButtonGroup } from './SupplierButtonGroup';
import { useState } from 'react';
import { sortSupplierItemPackageType } from '@retail/products/utils';

interface Props {
  mgItem: MgItemCard;
}

export type SupplierItemPackage = MgSupplierItemPackage & {
  mgSupplierName: string;
  mgSupplierId: number;
};

export function SupplierItems({ mgItem }: Props) {
  const [selectedSupplier, setSelectedSupplier] = useState<Partial<MgSupplierItemCard> | null>(
    null
  );

  const suppliers = mgItem.getSuppliers();
  const packages: SupplierItemPackage[] = [];

  mgItem.mgSupplierItems.forEach((supplierItem) => {
    supplierItem.mgSupplierItemPackages.forEach((pkg) => {
      packages.push({
        ...pkg,
        mgSupplierName: supplierItem.mgSupplier.name,
        mgSupplierId: supplierItem.mgSupplier.mgSupplierId,
      });
    });
  });

  const sortedPackages = packages.sort(sortSupplierItemPackageType);

  return (
    <Stack pt={2} gap={2}>
      <SupplierButtonGroup
        suppliers={suppliers}
        selectedSupplier={selectedSupplier}
        setSelectedSupplier={setSelectedSupplier}
      />
      <MgSupplierItemPackagesTable packages={sortedPackages} selectedSupplier={selectedSupplier} />
    </Stack>
  );
}
